export const routes = {
  home: '/explorer',
  explorerOrder: '/explorer/order/:orderId',
  explorerProduct: '/explorer/product/:productId',
  explorerAddress: '/explorer/address/:address'
}
